var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.69-227.69v-473.85h67.69v473.85h-67.69Zm101.54 0v-473.85h67.69v473.85h-67.69Zm101.54 0v-473.85h33.85v473.85h-33.85Zm101.54 0v-473.85H480v473.85h-67.69Zm101.54 0v-473.85h101.53v473.85H513.85Zm135.38 0v-473.85h33.85v473.85h-33.85Zm101.54 0v-473.85h101.54v473.85H750.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.82fd2f71e0ef1fc73c2169df2f44eed1.svg";
export { ForwardRef as ReactComponent };